'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _image = require('common/components/image');

var _image2 = _interopRequireDefault(_image);

var _extend = require('lodash/object/extend');

var _extend2 = _interopRequireDefault(_extend);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _signature = require('hellosign/models/signature');

var _signature2 = _interopRequireDefault(_signature);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _signatureEditArea = require('./signature-edit-area');

var _signatureEditArea2 = _interopRequireDefault(_signatureEditArea);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.upload.button.text'
});

var _ref2 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.upload.instructions.fileSize'
});

var _ref3 = _jsx('br', {});

var _ref4 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.upload.instructions.fileFormats'
});

var UploadTab = _react2['default'].createClass({
    displayName: 'UploadTab',


    propTypes: {
        'app': _react2['default'].PropTypes.object.isRequired,
        'type': _react2['default'].PropTypes.string.isRequired,
        'onBeforeInsert': _react2['default'].PropTypes.func.isRequired,
        'onInsert': _react2['default'].PropTypes.func.isRequired,
        'onClose': _react2['default'].PropTypes.func.isRequired,
        'onError': _react2['default'].PropTypes.func.isRequired,
        'isSelected': _react2['default'].PropTypes.bool.isRequired,
        'deviceOrientation': _react2['default'].PropTypes.string.isRequired,
        'screenSize': _react2['default'].PropTypes.string.isRequired,
        'locales': _react2['default'].PropTypes.array.isRequired,
        'messages': _react2['default'].PropTypes.object.isRequired,
        'isMobile': _react2['default'].PropTypes.bool.isRequired,
        'canInsertEverywhere': _react2['default'].PropTypes.bool,
        'buttonText': _react2['default'].PropTypes.string // Text to be displayed on the CTA (only when canInsertEverywhere=false)
    },

    //  ----  LIFECYCLE  ----------------------------------

    getInitialState: function getInitialState() {
        return {
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
            'isSpinnerShown': false,
            'isEditAreaShown': false,
            'signature': null
        };
    },

    //  ----  BEHAVIOR  -----------------------------------

    insertSignature: function insertSignature(insertEverywhere) {

        var self = this;
        var uploadEditArea = this.refs.uploadEditArea;
        var params = {};
        var isCropped = uploadEditArea.state.isCropped;

        if (isCropped) {
            params = {
                'is_cropped': isCropped,
                'x': uploadEditArea.state.cropX,
                'y': uploadEditArea.state.cropY,
                'width': uploadEditArea.state.cropWidth,
                'height': uploadEditArea.state.cropHeight
            };
        }

        params.threshold = uploadEditArea.state.contrastValue;
        params.degrees = uploadEditArea.state.degreesValue;
        params.guid = this.state.signature.guid;

        var signatureData = (0, _extend2['default'])((0, _extend2['default'])({}, this.state.signature.data), params);

        if (!this.props.onBeforeInsert || this.props.onBeforeInsert(signatureData) !== false) {

            // Notifies creation has started
            this.props.onInsert(null, null, true);

            // Create the signature and inserts it
            this.createSignature(params).then(function (signature) {
                self.props.onInsert(signature, insertEverywhere);
            })['catch'](function (error) {
                self.props.onError(error);
            });
        }
    },

    createSignature: function createSignature(signatureData) {
        // Set parameters from edit pane
        this.state.signature.setEditParams(signatureData);
        // Then get list of signatures, and use the edit endpoint to add
        return this.props.app.user.getSignatures(this.props.type).addFromEdit(this.state.signature);
    },

    //  ----  HELPERS  ------------------------------------

    onDrop: function onDrop(files) {

        var file = files[0]; // We only accept one

        this.checkTypeAndSize(file);

        var sig = _signature2['default'].create({
            'notifier': this.props.app.notifier,
            'file': file
        });
        sig.createType = _constants2['default'].SIGNATURE_TYPE_UPLOAD;
        sig.type = this.props.type;

        this.showSpinner();

        sig.save(function (err, data) {

            if (err) {
                this.props.onError(err);
            }

            this.setState({
                'signature': sig
            });

            this.hideSpinner();
            this.showEditArea();
        }.bind(this));
    },

    showEditArea: function showEditArea() {
        this.setState({
            'isEditAreaShown': true
        });
    },

    hideEditArea: function hideEditArea() {
        this.setState({
            'isEditAreaShown': false
        });
    },

    showSpinner: function showSpinner() {
        this.setState({
            'isSpinnerShown': true
        });
    },

    hideSpinner: function hideSpinner() {
        this.setState({
            'isSpinnerShown': false
        });
    },

    checkTypeAndSize: function checkTypeAndSize(file) {
        this.checkFileExtension(file);
        this.checkFileSize(file);
    },

    checkFileExtension: function checkFileExtension(file) {
        if (file.type && _constants2['default'].ACCEPTED_UPLOAD_TYPES.indexOf(file.type) === -1) {

            var errorMessage = this.props.intl.formatMessage({ id: 'signModal.upload.error.fileType' }, { 'fileType': file.type }) + ' ' + this.props.intl.formatMessage({ id: 'signModal.upload.instructions.fileFormats' });

            this.props.onError(new Error(errorMessage));
            return false;
        }
    },

    checkFileSize: function checkFileSize(file) {
        if (file.size && file.size > _constants2['default'].MAX_UPLOAD_SIZE) {

            var formattedSize = Math.round(file.size / 1000000) + 'MB';

            var errorMessage = this.props.intl.formatMessage({ id: 'signModal.upload.error.fileSize' }, { 'fileSize': formattedSize }) + ' ' + this.props.intl.formatMessage({ id: 'signModal.upload.instructions.fileSize' });

            this.props.onError(new Error(errorMessage));
            return false;
        }
    },

    //  ----  RENDERING  ----------------------------------

    renderUploadArea: function renderUploadArea() {

        var show = this.state.isEditAreaShown ? { 'display': 'none' } : {};
        var btnText = this.props.intl.formatMessage({ id: 'signModal.upload.button.text' });

        var uploadButton = _react2['default'].createElement(
            _reactDropzone2['default'],
            { onDrop: this.onDrop,
                onClick: this.onDrop,
                multiple: false,
                ref: 'dropzone', className: 'whitelabel-primary-button dropzone',
                style: {
                    'width': 60 + btnText.length * 10,
                    'height': 40
                },
                borderStyle: 'none' },
            _jsx('div', {}, void 0, _jsx(_image2['default'], {
                url: require('./upload_icon@2x.png')
            }), _ref)
        );

        return _jsx('div', {
            className: 'm-sign-modal--tabs--upload--fileupload',
            style: show
        }, void 0, _jsx('span', {
            className: 'm-sign-modal--tabs--upload--header-text'
        }, void 0, _jsx(_reactIntl.FormattedMessage, {
            id: 'signModal.upload.instructions.header',
            values: { type: this.props.type }
        })), uploadButton, _jsx('span', {
            className: 'm-sign-modal--tabs--upload--file-formats-text'
        }, void 0, _ref2, _ref3, _ref4));
    },

    renderEditArea: function renderEditArea() {

        var show = !this.state.isEditAreaShown ? { display: 'none' } : {};

        return _jsx('div', {
            style: show
        }, void 0, _react2['default'].createElement(_signatureEditArea2['default'], _extends({}, this.props, {
            signature: this.state.signature,
            ref: 'uploadEditArea'
        })));
    },

    render: function render() {

        var changeLink;
        var spinner;

        var inputClasses = {
            'm-sign-modal--tabs--upload--input': true
        };
        var classes = {
            'm-sign-modal--tabs--upload': true
        };
        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };

        containerClasses[_constants2['default'].TAB_UPLOAD] = true;

        if (this.state.isSpinnerShown) {
            spinner = _jsx('img', {
                src: require('./loading-spinner-16.gif'),
                className: 'm-sign-modal--tabs--upload--output--spinner'
            });
        }

        return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(containerClasses), ref: 'uploadTab' },
            _jsx('span', {
                className: 'm-sign-modal--tabs--tab-title'
            }, void 0, _jsx(_reactIntl.FormattedMessage, {
                id: 'signModal.upload.title',
                values: { type: this.props.type }
            })),
            _jsx('div', {
                className: (0, _classnames2['default'])(classes)
            }, void 0, _jsx('div', {
                className: (0, _classnames2['default'])(inputClasses)
            }, void 0, _jsx('div', {
                className: 'm-sign-modal--tabs--content'
            }, void 0, this.renderUploadArea(), spinner, this.renderEditArea()))),
            _react2['default'].createElement(_actionBar2['default'], _extends({}, this.props, {
                values: { type: this.props.type },
                isMobile: this.props.isMobile,
                locales: this.props.locales,
                messages: this.props.messages,
                onInsert: this.insertSignature,
                canInsertEverywhere: this.props.canInsertEverywhere,
                buttonText: this.props.buttonText,
                onClose: this.props.onClose,
                disableButtons: !this.state.isEditAreaShown }))
        );
    }
});

module.exports = UploadTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/upload-tab.jsx
 ** module id = 696
 ** module chunks = 0
 **/